var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.loginStatus)?_c('div',[_c('login',{on:{"login-success":_vm.setUser}})],1):_c('div',{staticClass:"main-container home-container"},[_c('HomePage')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }